import styled from 'styled-components';
import { size } from 'polished';

export const StyledVhTracker = styled.div`
  ${size('100vh', '0')};
  position: absolute;
  visibility: hidden;
`;
